package com.eladfinish.bible.contest.screens.main.ui.dialogs

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.MaterialTheme
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import androidx.compose.ui.unit.sp
import com.eladfinish.bible.contest.SharedRes
import com.eladfinish.bible.contest.not_now
import com.eladfinish.bible.contest.screens.main.MainScreenAction
import com.eladfinish.bible.contest.watch_ad
import dev.icerock.moko.resources.compose.stringResource

@Composable
internal fun ConfirmAdDialog(
    onAction: (MainScreenAction) -> Unit,
    title: String,
    content: String,
    onConfirm: () -> Unit,
) {
    AlertDialog(
        onDismissRequest = { onAction(MainScreenAction.HideDialog) },
        title = {
            Text(
                text = title,
                style = MaterialTheme.typography.titleLarge,
            )
        },
        text = {
            Text(
                text = content,
                style = MaterialTheme.typography.bodyLarge.copy(
                    fontSize = 18.sp
                )
            )
        },
        confirmButton = {
            TextButton(
                onClick = onConfirm
            ) {
                Text(text = stringResource(SharedRes.strings.watch_ad))
            }
        },
        dismissButton = {
            TextButton(
                onClick = { onAction(MainScreenAction.HideDialog) }
            ) {
                Text(text = stringResource(SharedRes.strings.not_now))
            }
        }
    )
}
